import AngularTemplate from 'core/angular';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';

import { AngularListSegmentContextProvider } from './contexts/AngularListSegmentContextProvider';
import { AudienceInsightsDrawer } from './audienceInsights/AudienceInsightsDrawer';
import {
  AUDIENCE_INSIGHTS_DRAWER_EXPANSION_KEY,
  CATALOG_QUERY_DRAWER_EXPANSION_KEY,
} from './constants';
import { CatalogQueryDrawer } from './catalogQuery';
import { AngularCatalogQueryContextProvider } from './contexts/AngularCatalogQueryContextProvider';
import { useAngularSegmentationError } from './hooks';

/**
 * AngularTemplate is implemented in Angular
 *
 * See app/views/users/listSegment.scala.html in Iterable.git for more details.
 */

export const SegmentationPage = () => {
  useAngularSegmentationError();

  return (
    <>
      <AngularTemplate />
      <ExpansionContextProvider
        localKey={AUDIENCE_INSIGHTS_DRAWER_EXPANSION_KEY}
        initialMode={ExpandModes.collapse}
      >
        <AngularListSegmentContextProvider>
          <AudienceInsightsDrawer />
        </AngularListSegmentContextProvider>
      </ExpansionContextProvider>
      <ExpansionContextProvider
        localKey={CATALOG_QUERY_DRAWER_EXPANSION_KEY}
        initialMode={ExpandModes.collapse}
      >
        <AngularCatalogQueryContextProvider>
          <CatalogQueryDrawer />
        </AngularCatalogQueryContextProvider>
      </ExpansionContextProvider>
    </>
  );
};
